import Realisations from '../Realisations.js';

/**
 * Class Restaurants
 */
class Restaurants extends Realisations{


  /**
   * Load realisations
   */
  loadRealisations() {
    this.ajax("/wp-json/wp/v2/realisations?domaines=5&per_page=" + this.perPageFirst).then(
      function(result) {
        var data= JSON.parse(result);
        document
          .getElementById(this.currentPageId)
          .setAttribute("id", "realisationsFilterRestaurants-page-container");
        this.currentPageId = "realisationsFilterRestaurants-page-container";
        var index = 1;
        this.realisations = [];
        // disable pagination if no more pages
        if(data.length < 12){
          this.pagination = 0;
        }
        if(data.length > 0){
          for (var item of data){
            var realisation = [];
            realisation['title'] = item.title.rendered;
            realisation['href']= item.link;
            realisation['id'] = item.id;
            // check if featured media is available
            realisation['thumbnail']
              = (item["_links"]["wp:featuredmedia"])
              ? item["_links"]["wp:featuredmedia"][0]['href']
              : "";
            this.realisations.push(realisation);
          }
          this.multipleCallbackMedia(this.realisations.length-1);
        } else {
          console.log('no item');
          this.display();
        }
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Load next realisations
   */
  loadNextRealisations() {
    console.log('load next realisations');
    if (this.pagination > 0) {
      console.log('current pagination')
      console.log(this.pagination);
      this.pagination++;
      console.log('new pagination')
      console.log(this.pagination);
      this.ajax("/wp-json/wp/v2/realisations?domaines=5&per_page="+this.perPage+"&page="+this.pagination).then(
          function(result) {
            var data= JSON.parse(result);
            var index = 1;
            this.realisations = [];
            for (var item of data){
              var realisation = [];
              realisation['title'] = item.title.rendered;
              realisation['href']= item.link;
              realisation['id'] = item.id;
              // check if featured media is available
              realisation['thumbnail']
                = (item["_links"]["wp:featuredmedia"])
                ? (item["_links"]["wp:featuredmedia"][0]['href'])
                : "";
              this.realisations.push(realisation);
            }
            console.log("number of fetched realisations");
            console.log(this.realisations.length);
            if (this.realisations.length < 1) {
              this.pagination = 0;
              this.motion.enableScroll();
            }
            else if (this.realisations.length < this.perPage) {
              this.pagination = 0;
              // @TODO: ugly code, refactor
              document.getElementById('realisations-spinner').style.display = "block";
              this.multipleCallbackMedia2(this.realisations.length-1);
            }
            else{
              // @TODO: ugly code, refactor
              document.getElementById('realisations-spinner').style.display = "block";
              this.multipleCallbackMedia2(this.realisations.length-1);
            }
          }.bind(this)
      ).catch(function(msg) {
        console.log(msg);
      });
    } else {
      console.log('pagination is blocked');
      this.setEventsListeners();
      this.motion.enableScroll();
      this.disablePagination();
    }
  }


}

export default Restaurants;
